import { stringArrayToSelectOptions } from '@/utils/misc.ts'

export const HcRole = {
  SuperAdmin: 'human-capital-super-admin',
  CountryAdmin: 'human-capital-country-admin',
  Developer: 'human-capital-developer',
  ExecutiveAssistant: 'human-capital-executive-assistant',
}

export const FinanceRole = {
  Operator: 'human-capital-finance-operator',
}

export type HcRole = typeof HcRole[keyof typeof HcRole]
export const HcRoleOptions = stringArrayToSelectOptions(Object.values(HcRole))
export const AllHcRoles = Object.values(HcRole)